import { useInjectWebSite } from "@made-people/grease-structured-data";
import type { WebSiteConfig } from "@made-people/grease-structured-data";
import { useFrontendContext } from "../../hooks/use-frontend-context";
import { useGetWebSiteSettings } from "../../hooks/use-website-settings";

export const MmWebsiteStructuredData = () => {
  const frontendContext = useFrontendContext();
  const webSiteSettings = useGetWebSiteSettings();

  const config: WebSiteConfig | undefined =
    frontendContext && webSiteSettings
      ? {
          url: frontendContext.baseUrl.toString(),
          name: webSiteSettings.name,
          description: webSiteSettings.description,
          inLanguage: `${frontendContext.language}-${frontendContext.country}`,
          keywords: webSiteSettings.keywords,
          searchActionUrlTemplate: `${frontendContext.baseUrl.toString()}/search?q={search_term_string}`,
          logoUrl: webSiteSettings.logoUrl,
          logoCaption: webSiteSettings.logoCaption,
          logoLanguage: `${frontendContext.language}-${frontendContext.country}`,
          sameAs: webSiteSettings.sameAs
            ? webSiteSettings.sameAs
                .split(",")
                .map((url) => url.trim())
                .filter((url) => url.length > 0)
            : undefined,
        }
      : undefined;

  useInjectWebSite(config);

  return null;
};
